import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import { useTranslation } from 'react-i18next';

import { useMemo } from 'react';
import ISelectorProps from '../../interfaces/ISelectorProps';
import getUserLanguage from '../../../../utils/languageUtils';

function LanguageSelector({
    selectedPreferences,
    setSelectedPreferences,
}: Readonly<ISelectorProps>) {
    const { t } = useTranslation();

    const arrayLanguages: DefaultOptionType[] = useMemo(
        () => [
            { value: 'pt-BR', label: 'Português' },
            { value: 'en-US', label: 'English' },
            { value: 'es-ES', label: 'Español' },
        ],
        [],
    );

    const getDefaultLanguage = getUserLanguage(selectedPreferences.language);

    return (
        <span
            className="select-autocomplete-label"
            data-testid="preferenceUser-Idioma-label"
        >
            {t('Language')}
            <Select
                defaultValue={getDefaultLanguage}
                options={arrayLanguages}
                onChange={value =>
                    setSelectedPreferences({
                        ...selectedPreferences,
                        language: value,
                    })
                }
                data-testid="user-preference-select"
            />
        </span>
    );
}

export default LanguageSelector;
